import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
import { ThemeContext } from "../context";
import Me from "../images/Me.png";
import { mobile } from "../Responsive";

// Css animations
const move = keyframes`
25%{
transform:translateY(-50px)
}
50%{

    transform:translateY(-100px)
}
70%{

    transform:translateY(-150px)
}
100%{

    transform:translateY(-200px)
}
`;
// Css animations

// Css components
const IntroContainer = styled.div`
  display: flex;
  height: 100vh;
  ${mobile({ flexDirection: "column" })}
`;
const IntroLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.color ? "#fff" : "#272727")};
`;

const IntroLeftWrapper = styled.div`
  padding: 50px;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  ${mobile({
    padding: "10px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    height: "100%",
  })}
`;
const IntroIntro = styled.h2`
  font-size: 30px;
  font-weight: 300;
`;
const IntroName = styled.h1`
  font-size: 60px;
`;
const IntroTitle = styled.div`
  height: 50px;
  overflow: hidden;
`;
const IntroTitleWrapper = styled.div`
  height: 100%;
  animation: ${move} 6s ease-in-out infinite alternate;
`;
const IntroTitleItem = styled.div`
  height: 50px;
  font-size: 30px;
  font-weight: bold;
  color: #761dfd;
  display: flex;
  align-items: center;
`;
const IntroDesc = styled.p`
  ${mobile({ display: "none" })}
`;
const IntroScroll = styled.svg`
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 20px;
`;

const IntroRight = styled.div`
  flex: 1;
  position: relative;
`;
const IntroImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
`;
const IntroBg = styled.div`
  clip-path: polygon(100% 0%, 100% 52%, 100% 100%, 25% 100%, 0% 50%, 25% 0%);
  background-color: #6411ad;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
`;

// Css components

const Intro = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <IntroContainer>
      <IntroLeft color={darkMode}>
        <IntroLeftWrapper>
          <IntroIntro>Hello, My name is</IntroIntro>
          <IntroName>Gaurav Meena</IntroName>
          <IntroTitle>
            <IntroTitleWrapper>
              <IntroTitleItem>Front-end Developer</IntroTitleItem>
              <IntroTitleItem>UI/UX Designer</IntroTitleItem>
              <IntroTitleItem>Back-end Developer</IntroTitleItem>
              <IntroTitleItem>Photographer</IntroTitleItem>
              <IntroTitleItem>Full stack Developer</IntroTitleItem>
            </IntroTitleWrapper>
          </IntroTitle>
          <IntroDesc>
            I design and develop services for customers of all sizes,
            specializing in creating stylish, modern websites, web services and
            online stores.
          </IntroDesc>
        </IntroLeftWrapper>
        <IntroScroll
          width="75"
          height="75"
          viewBox="0 0 75 75"
          fill="none"
          stroke={darkMode ? "#fff" : "#272727"}
          className="i-scroll"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="scroll">
            <path
              id="Vector"
              d="M40.5 15L34.5 9L28.5 15"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="Vector_2"
              d="M28.5 24L34.5 30L40.5 24"
              stroke-width="3"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <g id="Group">
              <path
                id="Vector_3"
                d="M9 37.5H60"
                stroke-width="3"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <path
              id="Vector_4"
              d="M34.5 27V9"
              stroke-width="2.9895"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <g id="Group_2">
              <path
                id="Vector_5"
                d="M9 27C9 12.918 20.418 1.5 34.5 1.5C48.5859 1.5 60 12.918 60 27C60 29.8906 60 45.1094 60 48C60 62.082 48.5859 73.5 34.5 73.5C20.418 73.5 9 62.082 9 48C9 45.1094 9 29.8906 9 27Z"
                stroke-width="3"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </g>
        </IntroScroll>
      </IntroLeft>
      <IntroRight>
        <IntroBg>
          <IntroImg src={Me} />
        </IntroBg>
      </IntroRight>
    </IntroContainer>
  );
};

export default Intro;
